import React, { FunctionComponent } from 'react';
import { DatePicker as ChromaDatePicker } from '@iag-packages/chroma-react/lib/components';
import { Moment } from 'moment';

import styled from 'styled-components';
import THEME from 'theme';

const DatepickerWrapper = styled.div`
  .c-datepicker {
    min-width: 100% !important;

    .SingleDatePickerInput {
      min-width: 100% !important;

      .SingleDatePickerInput_calendarIcon {
        z-index: 99;
      }

      .DateInput {
        min-width: 100% !important;

        .DateInput_input {
          border: ${THEME.FIELD.BORDER.NORMAL} solid ${THEME.FIELD.BORDER.VALID} !important;
          border-radius: 6px !important;
        }
        .DateInput_input:hover {
          border: ${THEME.FIELD.BORDER.SELECTED} solid
            ${THEME.FIELD.BORDER.VALID} !important;
          border-radius: 6px !important;
        }
        .DateInput_input__focused {
          border: ${THEME.FIELD.BORDER.SELECTED} solid
            ${THEME.FIELD.BORDER.VALID} !important;
          border-radius: 6px !important;
        }
      }
    }
  }
`;

type Props = {
  id: string;
  value: string;
  onChange: Function;
  screenReaderInputMessage?: string;
  displayFormat: string;
  isOutsideRange: (day: Moment) => boolean;
  numberOfMonths: number;
  ariaLabel?: string;
  ariaLabelledBy?: string;
};

export const DatePicker: FunctionComponent<Props> = ({
  value,
  onChange,
  screenReaderInputMessage,
  displayFormat,
  isOutsideRange,
  numberOfMonths,
  id,
  ariaLabel,
}) => (
  <DatepickerWrapper>
    <ChromaDatePicker
      value={value}
      onChange={onChange}
      ariaLabel={ariaLabel ?? ''}
      screenReaderInputMessage={screenReaderInputMessage}
      displayFormat={displayFormat}
      isOutsideRange={isOutsideRange}
      numberOfMonths={numberOfMonths}
      id={id}
      hideKeyboardShortcutsPanel
    />
  </DatepickerWrapper>
);

export default DatePicker;
